import { useState, useEffect } from "react";
import Modal from '../../../../core/components/core/Util/Modal/CustomModal';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import Fetch from "../../../../core/util/core/Fetch";
import config from '../../../config/config';
import { useDispatch } from 'react-redux';
import Toast from "../../../../core/components/core/Util/Toast/Toast"


function CancelSale({ show, onClose, saleId }) {
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();


    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/sales/cancel`,
        endpointGetAllReasons: `${endpointBackend}gci/reasons/getall`,
        endpointGetById: `${endpointBackend}gci/sales/getById`,
        endpointGetReceivedRevenuesBySale: `${endpointBackend}gci/revenues/getReceivedRevenuesBySale`,
    };

    // ---------- FORM CONFIG ----------
    const getForm = (values) => {
        const form = {
            afterSubmit: (form, values) => {
                onClose();
                dispatch({ type: 'UPDATE_SESSION', key: 'custom_list_reload', value: new Date() });
            },
            id: saleId,
            fields: [
                {
                    name: 'gci_reason_id',
                    type: 'select',
                    label: 'Motivo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllReasons,
                        label: 'name',
                        value: 'id',
                    },
                    validations: {
                        required: true,
                        hasReceivedRevenues: true
                    },
                    columnSize: 12
                },
                {
                    name: 'cancel_obs',
                    type: 'textarea',
                    label: 'Observação',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                hasReceivedRevenues: async (values) => {
                    const receivedRevenues = await Fetch.post(paths.endpointGetReceivedRevenuesBySale, {
                        id: saleId
                    });

                    if (receivedRevenues.length > 0) {
                        Toast.error('Não é possível cancelar a venda, pois já existem pagamentos realizados.');
                        return '^'
                    }

                    return '';
                }
            },
            labelSubmitButton: "Confirmar",
            showGoBackButton: false,
            ...paths,
        };

        form.values = values;
        return form;
    };

    // ---------- LOAD FORM ----------
    useEffect(() => {
        const load = async () => {
            if (!show) return;

            setLoading(true);

            let values = {};

            // Caso precise carregar dados da venda
            if (saleId) {
                values = await Fetch.post(paths.endpointGetById, { id: saleId });
            }

            const form = getForm(values);

            setForm(form);

            setFormContent(
                <CustomForm form={form} />
            );

            setLoading(false);
        };

        load();
    }, [show, saleId]);

    return (
        <Modal
            show={show}
            handleShow={() => { }}
            handleClose={onClose}
            handleConfirm={() => { }}
            title="Cancelar Venda"
            content={loading ? "Carregando..." : formContent}
            showButtons={false}
            showHeader={true}
        />
    );
}

export default CancelSale;